const UserLost = () => {
  return (
    <div className='centered-container'>
      <div className='success-content'>
        <img
          src='lost.svg'
          className='svg-illustration'
          alt='Gebruiker illustratie'
        />
        <div className='success-text-wrapper'>
          <h1>Volgens mij bent u verdwaalt</h1>
          <p>Fout: bedrijfs-ID ontbreekt</p>
        </div>
      </div>
    </div>
  );
};

export default UserLost;
